var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosGeoTraxVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193,
    height: 92,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#008EF3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "115.2%",
    height: "111.5%",
    x: "-7.6%",
    y: "-4.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M96.488 0C83.82 0 73.515 10.197 73.515 22.726c0 5.184 3.77 13.045 11.205 23.359l.662.918.66-.918c3.04-4.235 4.264-5.949 4.686-6.797l6.188-8.93c3.957-.226 7.108-3.44 7.108-7.409 0-4.115-3.375-7.452-7.536-7.452s-7.533 3.337-7.533 7.452c0 .955.197 1.86.528 2.698l-3.482 5.387c-1.876-3.144-3.044-5.836-3.044-8.308 0-7.352 6.072-13.334 13.53-13.334 7.463 0 13.535 5.982 13.535 13.334 0 4.578-3.7 9.798-8.814 17.018L90.748 53.95l.395.485c2.722 3.347 4.716 5.583 4.736 5.603l.609.682.609-.679c.91-1.018 22.364-25.042 22.364-37.315C119.461 10.197 109.155 0 96.488 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#151F28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.77 70.942v4.859h7.296v15.79h6v-15.79h7.323v-4.859zm25.741 12.021h1.5c1.44 0 2.236-.737 2.236-1.826 0-1.09-.824-1.767-2.177-1.767h-1.559zm2.41-7.154c4.208 0 6.65 1.471 6.65 4.914 0 1.651-.825 3.27-2.06 4.064.822.59 1.412 2.12 1.824 3.181l1.44 3.622h-5.5l-1.087-3.297c-.53-1.59-1-2.21-2.09-2.21h-1.587v5.507h-5.116V75.81h7.527z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.896 81.05-1.617 5.18h3.704zm3.06-5.241 6.853 15.78h-5.884l-.793-2.178h-5.764l-.589 2.178h-5.41l5.88-15.78h5.706z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.078 75.808 3 4.532 2.999-4.532h6.263l-6.146 7.567 6.677 8.216h-6.265l-3.528-5.155-3.532 5.155h-6.263l6.646-8.216-6.147-7.567zm-90.09 1.338c-2.19-1.29-4.2-1.773-6.75-1.773-5.579 0-7.078 3.664-7.078 6.07 0 3.062 2.25 5.705 6.389 5.705.961 0 1.619-.09 2.49-.301v-2.433h-2.76V80.3h8.099v9.85c-3.238 1.26-6.03 1.711-8.998 1.711-6.689 0-11.46-3.843-11.46-10.511 0-5.556 3.811-10.512 11.819-10.512 2.968 0 5.22.362 8.25 1.471v4.836zm14.109-1.33v3.621h-6.91v2.385h6.587v3.386h-6.588v2.766h7.087v3.624H57.068V75.816zm9.727 11.394c1.852 0 3.5-1.297 3.5-3.505 0-1.913-1.325-3.503-3.5-3.503-2.149 0-3.471 1.531-3.471 3.503 0 2.093 1.322 3.504 3.47 3.504m-.03-11.6c4.912 0 8.854 3.24 8.854 8.068 0 5.153-4 8.127-8.823 8.127-5.411 0-8.793-3.417-8.793-8.068 0-4.418 3.5-8.127 8.762-8.127"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#000",
    filter: "url(#a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "url(#c)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosGeoTraxVertical);
export default __webpack_public_path__ + "static/media/logos-geo-trax-vertical.4b99ebc514c7dd466b305f54426e66ce.svg";
export { ForwardRef as ReactComponent };